import React, { createContext, useState, useContext, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [isMenuPageEnabled, setIsMenuPageEnabled] = useState(true);
  const [isHaguimModeEnabled, setIsHaguimModeEnabled] = useState(false);
  const [haguimName, setHaguimName] = useState('');

  // Charger les paramètres depuis le localStorage au démarrage
  useEffect(() => {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      const parsedSettings = JSON.parse(storedSettings);
      setIsMenuPageEnabled(parsedSettings.isMenuPageEnabled ?? true);
      setIsHaguimModeEnabled(parsedSettings.isHaguimModeEnabled ?? false);
      setHaguimName(parsedSettings.haguimName ?? '');
    }
  }, []);

  // Sauvegarder les paramètres dans le localStorage à chaque changement
  useEffect(() => {
    const settings = {
      isMenuPageEnabled,
      isHaguimModeEnabled,
      haguimName
    };
    localStorage.setItem('appSettings', JSON.stringify(settings));
  }, [isMenuPageEnabled, isHaguimModeEnabled, haguimName]);

  const toggleMenuPage = (value) => {
    setIsMenuPageEnabled(value);
  };

  const toggleHaguimMode = (value) => {
    setIsHaguimModeEnabled(value);
  };

  const updateHaguimName = (name) => {
    setHaguimName(name);
  };

  return (
    <SettingsContext.Provider
      value={{
        isMenuPageEnabled,
        isHaguimModeEnabled,
        haguimName,
        toggleMenuPage,
        toggleHaguimMode,
        updateHaguimName
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext; 